"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-three/sections/blogSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogSection6412AosItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/blog/blog-38.jpg" | "/Templates/Doccure/img/blog/blog-39.jpg" | "/Templates/Doccure/img/blog/blog-40.jpg" */
    src: string;
    /** Detected variants: "29, Nov 2026" | "15, Sep 2026" | "16, Aug 2026" */
    p0Text: ReactNode;
    /** Detected variants: "all_routes.doctorProfile1" | "doctor-profile{all_routes.doctorProfile1}" */
    href: string;
    /** Detected variants: "/Templates/Doccure/img/patients/patient14.jpg" | "/Templates/Doccure/img/patients/patient15.jpg" | "/Templates/Doccure/img/patients/patient17.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "Dr. Ruby Perrin" | "Daniel Scott" | "Jacob Allen" */
    span0Text: ReactNode;
    /** Detected variants: "Cosmetics" | "Oral Surgery" | "General Dentistry" */
    p0P0Text: ReactNode;
    /** Detected variants: "Dental Myths vs Facts: What You Need to Know" | "The Connection Between Oral Health and Overall Wellness" | "How to Choose the Right Toothbrush and Toothpaste" */
    link0Text: ReactNode;
    /** Detected variants: "col-md-6 col-lg-4 col-sm-12 aos" */
    className?: string;
    /** Detected variants: "fade-up" */
    dataAos?: string;
    /** Detected variants: "blog grid-blog blog-item-three mb-0" */
    div0ClassName?: string;
    /** Detected variants: "blog-image" */
    div0ClassName2?: string;
    /** Detected variants: "all_routes.blogDetails" */
    link0Href?: string;
    /** Detected variants: "Post Image" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "date" */
    p0ClassName?: string;
    /** Detected variants: "blog-content" */
    div1ClassName?: string;
    /** Detected variants: "blog-info" */
    div0ClassName3?: string;
    /** Detected variants: "author" */
    div0ClassName4?: string;
    /** Detected variants: "Post Author" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "badge bg-light" */
    p0ClassName2?: string;
    /** Detected variants: "custom-title line-clamp-2" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.blogDetails" */
    link0Href2?: string;
};
export type HomeThreeBlogSectionGeneratedProps = {
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection6412AosItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection6412AosItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection6412AosItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1Div0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection6412AosItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection6412AosItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection6412AosItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "fade-up" */
    sectionDiv0Div0DivDataAos?: string;
    /** Default: "Latest Articles" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Resources & Blog" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Expert advice, tips, and insights to help you maintain a healthy, beautiful smile" */
    sectionDiv0Div0P0PText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    blogSection6412Aos: BlogSection6412AosItem[];
    blogSection6412AosItemWrapper?: (item: BlogSection6412AosItem, content: ReactNode) => ReactNode;
    blogSection6412AosRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogSection6412AosLinkVisible?: boolean;
    blogSection6412AosLinkRenderer?: (item: BlogSection6412AosItem, defaultNode: ReactNode) => ReactNode;
    blogSection6412AosImageVisible?: boolean;
    blogSection6412AosImageRenderer?: (item: BlogSection6412AosItem, defaultNode: ReactNode) => ReactNode;
    blogSection6412AosH3Visible?: boolean;
    blogSection6412AosH3Renderer?: (item: BlogSection6412AosItem, defaultNode: ReactNode) => ReactNode;
    blogSection6412AosLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection6412AosItem) => Partial<ComponentProps<typeof SmartLink>>);
    blogSection6412AosImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection6412AosItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    blogSection6412AosH3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection6412AosItem) => Partial<ComponentProps<"h3">>);
};

const HomeThreeBlogSectionGenerated: FC<HomeThreeBlogSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Latest Articles",
    sectionDiv0Div0DivDataAos = "fade-up",
    sectionDiv0Div0H20H2Text = "Resources & Blog",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0P0PText = "Expert advice, tips, and insights to help you maintain a healthy, beautiful smile",
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1Div0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    blogSection6412Aos,
    blogSection6412AosItemWrapper,
    blogSection6412AosRenderer,
    blogSection6412AosLinkVisible,
    blogSection6412AosLinkRenderer,
    blogSection6412AosImageVisible,
    blogSection6412AosImageRenderer,
    blogSection6412AosH3Visible,
    blogSection6412AosH3Renderer,
    blogSection6412AosLinkProps,
    blogSection6412AosImageProps,
    blogSection6412AosH3Props,
}) => {
    return (
        <section className="blog-section section pt-0">
            <div className="container">
                <div className="section-header section-header-three text-center aos" data-aos={sectionDiv0Div0DivDataAos}>
                    <div className="title">
                        <i className="fa-solid fa-circle" />
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    <p className="subtitle">{sectionDiv0Div0P0PText}</p>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row blog-grid-row justify-content-center g-4"}>
                    {renderCollectionNode(
                        blogSection6412Aos,
                        (item: BlogSection6412AosItem) => (
                            <div className={item.className ?? "col-md-6 col-lg-4 col-sm-12 aos"} data-aos={item.dataAos ?? "fade-up"} key={item.key}>
                                <div className={item.div0ClassName ?? "blog grid-blog blog-item-three mb-0"}>
                                    <div className={item.div0ClassName2 ?? "blog-image"}>
                                        {renderItemNode(blogSection6412AosLinkVisible, blogSection6412AosLinkRenderer, item, (
                                            <SmartLink href={item.link0Href ?? "all_routes.blogDetails"} {...(typeof blogSection6412AosLinkProps === "function" ? blogSection6412AosLinkProps(item) : (blogSection6412AosLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(blogSection6412AosImageVisible, blogSection6412AosImageRenderer, item, (
                                                    <SmartImage className={item.imageWithBasePath0ClassName ?? "img-fluid"} src={item.src} alt={item.alt ?? "Post Image"} {...(typeof blogSection6412AosImageProps === "function" ? blogSection6412AosImageProps(item) : (blogSection6412AosImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                        <p className={item.p0ClassName ?? "date"}>{item.p0Text}</p>
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-content"}>
                                        {renderItemNode(blogSection6412AosH3Visible, blogSection6412AosH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title line-clamp-2"} {...(typeof blogSection6412AosH3Props === "function" ? blogSection6412AosH3Props(item) : (blogSection6412AosH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(blogSection6412AosLinkVisible, blogSection6412AosLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href2 ?? "all_routes.blogDetails"} {...(typeof blogSection6412AosLinkProps === "function" ? blogSection6412AosLinkProps(item) : (blogSection6412AosLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <div className={item.div0ClassName3 ?? "blog-info"}>
                                            <div className={item.div0ClassName4 ?? "author"}>
                                                {renderItemNode(blogSection6412AosLinkVisible, blogSection6412AosLinkRenderer, item, (
                                                    <SmartLink href={item.href} {...(typeof blogSection6412AosLinkProps === "function" ? blogSection6412AosLinkProps(item) : (blogSection6412AosLinkProps ?? {}))} {...(typeof divDiv0Div1Div0Div0Link0LinkProps === "function" ? divDiv0Div1Div0Div0Link0LinkProps(item) : (divDiv0Div1Div0Div0Link0LinkProps ?? {}))}>
                                                        {renderItemNode(blogSection6412AosImageVisible, blogSection6412AosImageRenderer, item, (
                                                            <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "Post Author"} {...(typeof blogSection6412AosImageProps === "function" ? blogSection6412AosImageProps(item) : (blogSection6412AosImageProps ?? {}))} {...(typeof divDiv0Div1Div0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div1Div0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div1Div0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                        ))}
                                                        <span>{item.span0Text}</span>
                                                    </SmartLink>
                                                ))}
                                            </div>
                                            <p className={item.p0ClassName2 ?? "badge bg-light"}>{item.p0P0Text}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                        blogSection6412AosItemWrapper,
                        blogSection6412AosRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeThreeBlogSectionGenerated;
